import { Molecule, wrap, Wrapper } from 'AppReact'
import styled from 'styled-components'
import { SecondaryTextSm, SecondaryTextSmBold } from 'atoms';
import { FlexBoxWrapper, Mr2 } from "wrappers";

const template = styled.div``

export default Molecule({
  template,
  type: '',
  atoms: [
    {
      wrapper: FlexBoxWrapper,
      name: "Wrapper",
      atoms: [
          {
              component: wrap(SecondaryTextSmBold, Mr2),
              name: 'Label',
              displayValue: ({ label }) =>  `${label}: `,
            },
            {
              component: SecondaryTextSm,
              name: 'Value',
              displayValue: ({ value }) =>  value,
            },
      ]
     }
  ]
})
